class DD extends React.Component {

    onChange(val) {

        if (val === 'Refresh') {
            if (this.props.onRefresh) {
                this.props.onRefresh();
            }
        } else {
            this.props.onChange(val);
        }
    }

    render() {
        var self = this,
        tabindex = this.props.tabindex || '';

        return (
            <select
                value={this.props.value}
                className={'dd-base ' + (this.props.className ? this.props.className : '')}
                onChange={e => { this.onChange(e.target.value); }}
                disabled={this.props.disabled}
                tabindex={tabindex}
            >

                { this.props.options && this.props.options.map((data, i) => {
                    return (
                        <option
                            value={data.option}
                            key={'data.title'+i}>

                            {data.title}
                        </option>
                    );
                })}
            </select>
        );
    }
}

export default DD;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/dropdown/DD.react.jsx